import MsecDuratives from '../modules/MsecDuratives.js';

class TimelineMarker extends MsecDuratives {}

export default TimelineMarker;
